document.addEventListener("DOMContentLoaded", () => {

  const warrantyToggle = document.querySelector("[data-warranty-toggle]");
  const warrantyBlock = document.querySelector("[data-warranty-block]");
  if (!warrantyToggle || !warrantyBlock) return;

  const warrantyVariantId = warrantyBlock.dataset.productId;

  warrantyToggle.addEventListener("click", function() {
    warrantyToggle.classList.toggle("active");
  });

  // Intercept Add to Cart button
  const mainATC = document.querySelector("button[name='add']");
  mainATC.addEventListener("click", function(event) {

    // If warranty selected, send extra request
    if (warrantyToggle.classList.contains("active")) {

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          items: [{ id: warrantyVariantId, quantity: 1 }]
        })
      });
    }
  });

});

document.addEventListener('DOMContentLoaded', () => {
  const addBtns = document.querySelectorAll('.page-product [data-add-btn]');
  addBtns.forEach(btn => {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      // Always re-select CTA (Shopify replaces DOM)
      let mainCTA = document.querySelector('.product-form__buttons .product-form__submit');
      if (!mainCTA) return;
      // Scroll using window scroll (bypasses overflow issues)
      const rect = mainCTA.getBoundingClientRect();
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      window.scrollTo({
        top: rect.top + scrollTop - 80, // offset for sticky header
        behavior: 'smooth'
      });
      // Trigger click after scroll
      // setTimeout(() => {
      //   mainCTA.click();
      // }, 400);
    });
  });
});



  document.addEventListener('DOMContentLoaded', function () {
    const iconText = document.querySelector('.icontext-grid');
    const featuresGrid = document.querySelector('.features-grid');

    if (!iconText || !featuresGrid) return;

    // Create placeholder to restore position on desktop
    const placeholder = document.createElement('div');
    placeholder.className = 'icontext-placeholder';
    iconText.parentNode.insertBefore(placeholder, iconText);

    function handleMove() {
      if (window.innerWidth <= 768) {
        // Move to features grid (mobile)
        if (!featuresGrid.contains(iconText)) {
          featuresGrid.appendChild(iconText);
        }
      } else {
        // Restore to original position (desktop)
        if (placeholder.parentNode && placeholder.nextSibling !== iconText) {
          placeholder.parentNode.insertBefore(iconText, placeholder.nextSibling);
        }
      }
    }

    // Initial run
    handleMove();

    // Handle resize
    window.addEventListener('resize', handleMove);
  });








